import classNames from 'classnames'
import React from 'react'
import { isMobile } from 'react-device-detect'

export const IncludeAddTooltip = (props: any) => {
  const { setTooltipStatus } = props

  return (
    <div
      className={classNames(
        'flex flex-col p-[26px] gap-[10px] bg-white  w-[330px]   border-[3px] border-main  rounded-[20px] z-50',
        {
          ' fixed left-[40%] bottom-[25%] ': !isMobile,
          ' fixed bottom-[25%]  ': isMobile,
        }
      )}
    >
      <div className="flex items-center justify-between">
        <p className=" leading-[19.2px] text-base   text-[10px]">
          <span className="font-bold text-[20px]">안내 이미지 예시</span>
        </p>
        <button
          type="button"
          onClick={() => setTooltipStatus((prev: boolean) => !prev)}
        >
          <img
            src="assets/img/Icon_x.png"
            alt="icon_x"
            height={24}
            width={24}
          />
        </button>
      </div>
      <p>
        영상 우상단 구매링크 안내 이미지입니다. <br />
        (광고포함 문구는 유튜브 정책 필수)
      </p>
      <div className="flex flex-col gap-4">
        {' '}
        <img
          src="assets/img/includeAdd_add.png"
          alt=""
          className="w-[266px] h-[150px]"
        />
        <img
          src="assets/img/includeAdd_minus.png"
          alt=""
          className="w-[266px] h-[150px]"
        />
      </div>
    </div>
  )
}
